export default {
  isRequired: (msg) => {
    return v => (!!v && v.length > 0) || (msg || 'Campo requerido')
  },
  isEmail: v => {
    if (!v.length > 0) return true
    let regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    return regex.test(v) || 'Correo electrónico no válido'
  },
  isComposedBy: (option, value) => {
    let regex = {
      'letters|numbers|spaces': /^[A-zÀ-ÖØ-öø-ÿ0-9 ]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9 ]*$/,
      'numbers': /^[0-9]*[0-9][0-9]*$/
    }
    let msg = {
      'letters|numbers|spaces': 'Solo números, letras y espacios están permitidos',
      'numbers': 'Solo números están permitidos'
    }
    if (typeof value !== 'undefined' && typeof value === 'string') {
      return v => regex[option].test(v[value]) || msg[option]
    } else if (typeof value !== 'undefined') {
      return v => v.every(value => regex[option].test(value)) || msg[option]
    } else if (typeof value === 'undefined') {
      return v => regex[option].test(v) || msg[option]
    }
    return true
  },
  hasLength: (chars, value) => {
    let msg = 'Debe contener ' + chars + ' caracteres'
    if (typeof value !== 'undefined' && typeof value === 'string') {
      return v => v[value].length === chars || msg
    } else if (typeof value !== 'undefined') {
      return v => v.every(value => value.length === chars) || msg
    } else if (typeof value === 'undefined') {
      return v => v.length === chars || msg
    }
    return true
  },
  hasMaxLength: (chars, value) => {
    let msg = 'No debe exceder de ' + chars + ' caracteres'
    if (typeof value !== 'undefined' && typeof value === 'string') {
      return v => v[value].length <= chars || msg
    } else if (typeof value !== 'undefined') {
      return v => v.every(value => value.length <= chars) || msg
    } else if (typeof value === 'undefined') {
      return v => v.length <= chars || msg
    }
    return true
  },
  hasMinLength: (chars, value) => {
    let msg = 'Debe contener un mínimo de ' + chars + ' caracteres'
    if (typeof value !== 'undefined' && typeof value === 'string') {
      return v => v[value].length >= chars || msg
    } else if (typeof value !== 'undefined') {
      return v => v.every(value => value.length >= chars) || msg
    } else if (typeof value === 'undefined') {
      return v => v.length >= chars || msg
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/config/forms/validations.js